<template>

    <section class="c-settings_export_c">
        <h3>Eksportuj kalendarz</h3>
        <form-desc>Użyj specjalnie przygotowanego, indywidualnego adresu URL w celu eksportu kalendarza wizyty do
            swojego prywatnego kalendarza.
        </form-desc>
        <form-input
            v-model="pht.ics_calendar_url"
            label="Link do kalendarza"
            readonly>
        </form-input>
    </section>

</template>


<script>

import {mapGetters} from 'vuex'
import {FormRow, FormDesc, FormInput} from 'Components/Form'

export default {

    name: 'SettingsExportCalendar',

    computed: {
        ...mapGetters(['pht'])
    },

    components: {
        FormRow,
        FormDesc,
        FormInput,
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-settings_export_c {

}

</style>
